export type DistributionWorkflowStepProps = {
  onBack: () => void;
  onContinue: (error?: Error) => void;
};

export type PaymentCapabilities = {
  wirePayments: boolean;
  achPayments: boolean;
};

export const DEFAULT_PAYMENT_CAPABILITIES: PaymentCapabilities = {
  wirePayments: true,
  achPayments: false,
};
